/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {FormControl, FormGroup} from '@angular/forms';
import { CurrencyCode } from '@irian-ro/shared-components-module';

export class CurrencyValueModel extends JSONable {

  currencyCode: string | undefined = undefined;

  value: number | undefined = undefined;

  static createForm() {
    return new FormGroup({
      currencyCode: new FormControl(),
      value: new FormControl()
    });
  }

  static getDefaultValue() {
    const currencyValue = new CurrencyValueModel();
    currencyValue.currencyCode = CurrencyCode.RON;
    currencyValue.value = 0;
    return currencyValue;
  }
}
